<div class="oase-home">
  <mat-card appearance="outlined" *ngIf="!authService.benutzerdatenExists()" class="ladedaten center">
    <mat-card-content>
      {{ 'allgemein.daten.laden.start' | translate:locale.language }}
      <mat-icon>hourglass_empty</mat-icon>
      <mat-spinner color="accent"></mat-spinner>
      {{ 'allgemein.daten.laden.ende' | translate:locale.language }}
    </mat-card-content>
  </mat-card>
  <div *ngIf="kategorieTyp==0" class="kategorie_home link_home" [style.display]="onDesktop()">
    <mat-card appearance="outlined" (keypress)="openLink('http://www.kaerntnermilch.at')" (click)="openLink('http://www.kaerntnermilch.at')" class="kategorie_cards link_card">
      <img id="link_logo_ktnmilch" src="../assets/ktnmilch_logo2.png" alt="Kärntnermilch Logo">
      <a>www.kaerntnermilch.at</a>
    </mat-card>
    <mat-card appearance="outlined" (keypress)="openLink('http://www.biowiesenmilch.at')" (click)="openLink('http://www.biowiesenmilch.at')" class="kategorie_cards link_card">
      <img id="link_logo_biowiesen" src="../assets/biowiesenmilch_logo.png" alt="Bio Wisenmilch Logo">
      <a>www.biowiesenmilch.at</a>
    </mat-card>
  </div>
  <div class="kategorie_home">

    <mat-card appearance="outlined" *ngFor="let kategorie of data" class="kategorie_cards" (keypress)="goToEintraege(kategorie)" (click)="goToEintraege(kategorie)">
      <img *ngIf="kategorie.datei != null" mat-card-image [src]="getBildVerkleinertUrl(kategorie.datei, '/w376')" alt="{{ kategorie.bezeichnung }}" />
      <img *ngIf="kategorie.datei == null" mat-card-image src="../assets/noPhoto.png" alt="{{ kategorie.bezeichnung }}">
      <mat-card-title class="shorten-long-text">{{ kategorie.bezeichnung }}</mat-card-title>
      <mat-card-content>

        <span [ngClass]="{'ungeleseneEintraege' : kategorie.anzUngelNachr}">{{ kategorie.anzUngelNachr }}
          <span *ngIf="kategorie.anzUngelNachr != 1">{{ 'kategorie.ungeleseneNachrichten' | translate:locale.language }}</span>
          <span *ngIf="kategorie.anzUngelNachr == 1">{{ 'kategorie.ungeleseneNachricht' | translate:locale.language }}</span>
          &nbsp;{{kategorie.anzNachr}}
        </span>
        <a *ngIf="kategorie.anzNachr > 0" matTooltip="{{ 'eintrag.liste' | translate:locale.language }}"  mat-icon-button  style="align-content: center;">{{ 'allgemein.oeffnen' | translate:locale.language }}</a>
        <a *ngIf="kategorie.anzNachr == 0" disabled="true" matTooltip="{{ 'eintrag.liste' | translate:locale.language }}"  mat-icon-button  style="align-content: center;">{{ 'allgemein.oeffnen' | translate:locale.language }}</a>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" class="kategorie_cards" routerLink="/protected/shop" *ngIf="kategorieTyp==0">
      <img mat-card-image src="../assets/logo_strich.png" alt="Kaiser Shop Logo" />
      <mat-card-title>{{ 'Shop.subtitle' | translate:locale.language }} - {{ 'Shop.title' | translate:locale.language }}</mat-card-title>
      <mat-card-content>
        <span>{{ 'Shop.teaser' | translate:locale.language }}</span>
        <a matTooltip="{{ 'eintrag.liste' | translate:locale.language }}"  mat-icon-button  style="align-content: center;">{{ 'allgemein.oeffnen' | translate:locale.language }}</a>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="kategorie_home link_home mobile" *ngIf="kategorieTyp==0" [style.display]="onMobile()">
    <mat-card  appearance="outlined"  class="headerZeile" style="width:100%;">
      <mat-card-title class="center">
          {{ 'allgemein.webseiten' | translate:locale.language }}
      </mat-card-title>
      <mat-card appearance="outlined" (keypress)="openLink('http://www.kaerntnermilch.at')" (click)="openLink('http://www.kaerntnermilch.at')" class="kategorie_cards link_card">
        <img id="link_logo_ktnmilch" src="../assets/ktnmilch_logo2.png" alt="KTN Milch Logo">
        <a>www.kaerntnermilch.at</a>
      </mat-card>
      <mat-card appearance="outlined" (keypress)="openLink('http://www.biowiesenmilch.at')" (click)="openLink('http://www.biowiesenmilch.at')" class="kategorie_cards link_card">
        <img id="link_logo_biowiesen" src="../assets/biowiesenmilch_logo.png" alt="Biowiesenmilch Logo">
        <a>www.biowiesenmilch.at</a>
      </mat-card>
      </mat-card>
  </div>
  <div class="kategorie_home">
</div>
